import axios from '@/utils/api-axios'
import modulo from '@/utils/modulo'
import { SET_MUNICIPIOS, SET_MUNICIPIOS_PA } from '../../../mutation-types'

const state = {
  municipios: [],
  municipiosPA: []
}

const getters = {
  municipios: state => state.municipios,
  municipiosPA: state => state.municipiosPA
}

const mutations = {

  [SET_MUNICIPIOS] (state, municipios) {
    state.municipios = municipios
  },

  [SET_MUNICIPIOS_PA] (state, municipios) {
    state.municipiosPA = municipios
  }
}

const actions = {
  async findMunicipiosByUf ({ commit }, codigoEstado) {
    const municipios = await axios({
      method: 'get',
      url: modulo.PUBLICO + '/findByCodigoEstado',
      params: {
        codigoEstado
      }
    })

    commit('SET_MUNICIPIOS', municipios.data)

    return municipios.data
  },

  async findMunicipiosDoPara ({ commit }) {
    const municipios = await axios({
      method: 'get',
      url: modulo.PUBLICO + '/findByCodigoEstado',
      params: {
        codigoEstado: 'PA'
      }
    })

    commit('SET_MUNICIPIOS_PA', municipios.data)

    return municipios.data
  },

  async findMunicipiosPorEstado ({ commit }, estado) {
    const municipios = await axios({
      method: 'get',
      url: modulo.PUBLICO + '/findByCodigoEstado',
      params: {
        codigoEstado: estado
      }
    })

    commit('SET_MUNICIPIOS_PA', municipios.data)

    return municipios.data
  },

  async getSiglasEstados ({ commit }) {
    const data = await axios({
      method: 'GET',
      url: modulo.PUBLICO + `/getSiglasEstados`
    })
    return data
  },

  async findMunicipiosByEstadoAtual ({ commit }) {
    const municipios = await axios({
      method: 'get',
      url: modulo.PUBLICO + '/findByCodigoEstado',
      params: {
        codigoEstado: (process.env.ESTADO).toUpperCase()
      }
    })
    commit('SET_MUNICIPIOS', municipios.data)

    return municipios
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/portal/publico/municipiosPortal.js